import { BorderRadius, Colors, Media, Inset } from '@doordash/design-language'
import { HEADER_HEIGHT_PX } from '../../pages/landing/constants'
import styled from 'styled-components'
import { Section } from '@doordash/component-layout'

export const AlertWrapper = styled.div`
  word-break: break-word;
  background: ${Colors.SystemYellow20};
  border-radius: ${BorderRadius.Small}px;
`

type RootProps = {
  includeMobileHeader?: boolean
}

export const Root = styled<RootProps, 'div'>('div')`
  height: 100%;
  width: 100%;
  overflow-y: auto;
  background-color: ${Colors.PageBackgroundSecondary};
  padding-top: 70px;

  ${Media.Mobile`
    padding-top: ${HEADER_HEIGHT_PX}px;
    background-color: ${Colors.SystemWhite};
    height: 100%;
  `}
`

export const SafetyContentContainer = styled.div`
  svg {
    width: 100%;
  }
`

type SectionImageHeaderProps = {
  imageUrl: string
}
export const SectionImageHeader = styled<SectionImageHeaderProps, 'div'>('div')`
  background-image: url(${(props: SectionImageHeaderProps) => props.imageUrl});
  width: 100%;
  min-height: 222px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`
